function animateNavBtn() {
    const btn = $( ".nav-btn" )

    btn.on("click", function() {
        $(this).toggleClass("open")
        $(".mobile-navigation").fadeToggle()
    })

    $(".mobile-search-btn").on("click", function() {
        $(".mobile-navigation").fadeToggle()
        $(".nav-btn").toggleClass("open")
        $(".shop-search-bar--body").find("input").focus()
    })
}

$(document).ready( function() {
    animateNavBtn()
})
